import HTTPClientCache from "./http-client_cache";

// Override `maxAge` and cache URLs with query parameters
const options = {
  cache: {
      maxAge: 24 * 60 * 60 * 1000, // set cache time to 1 day (instead 15 minutes)
      exclude: { query: false } // cache requests with query parameters
  }
}

class DepartmentService {
  async getDepartmentsByOrganization(organizationId) {
    const httpClient = new HTTPClientCache();
    const api = await httpClient.configure();

    return api.get(`/departments/${organizationId}`, options);
  }

  async getDepartmentByIds(departmentId) {
    const httpClient = new HTTPClientCache();
    const api = await httpClient.configure();

    return api.get(`/department/${departmentId}`, options);
  }

  async getAllDepartments() {
    const httpClient = new HTTPClientCache();
    const api = await httpClient.configure();

    return api.get("/departments", options)
  }
}

export default new DepartmentService();
